import React from "react";
import { getPairDisplay, getPairMeta } from "../../pairMeta";
import { ReactComponent as ChevronIcon } from "@assets/images/icons/arrow-down.svg";

/**
 * Button with the currently selected pair that opens the asset modal.
 *
 * @param {object} props
 * @param {object|null} props.pair
 * @param {() => void} props.onClick
 */
export const PairTrigger = ({ pair, onClick }) => {
  const meta = getPairMeta(pair?.slug);
  const { title, ticker } = getPairDisplay(pair);

  return (
    <button
      data-futures-guide="asset-selection"
      onClick={onClick}
      type="button"
      className="futures-quote__current-pair"
    >
      {meta?.icon ? (
        <img
          className="futures-quote__current-pair-icon"
          src={meta.icon}
          alt=""
        />
      ) : (
        <div className="futures-quote__current-pair-icon-placeholder">#</div>
      )}

      <div className="futures-quote__current-pair-text-wrap">
        {ticker && (
          <span className="futures-quote__current-pair-ticker">{ticker}</span>
        )}
        <h3 className="futures-quote__current-pair-title">
          <span>{title}</span>
          {ticker && (
            <span className="futures-quote__current-pair-ticker futures-quote__current-pair-ticker--desktop">
              {ticker}
            </span>
          )}
        </h3>
      </div>

      <ChevronIcon className="futures-quote__current-pair-chevron" />
    </button>
  );
};
